import {createContext, useContext} from "react";

type WorkspaceBtlActivitiesContextData = Array<unknown>;

export const WorkspaceBtlActivitiesContext = createContext<WorkspaceBtlActivitiesContextData | undefined>(undefined);

export function useBtlActivities(): WorkspaceBtlActivitiesContextData {
    const data = useContext(WorkspaceBtlActivitiesContext);
    if (data === undefined) {
        return [];
    }

    return data;
}
